import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    height: "100%",
    fontSize: "4.5rem",
    textAlign: "center",
    background: `linear-gradient(180deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
    color: theme.palette.common.white,
    border: `solid 1px ${theme.palette.secondary[300]}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
}));

export default function DefaultProfileImage(props) {
  const classes = useStyles();
  const { firstInitial, lastInitial } = props;
  return (
    <div className={classes.root}>
      <span>{firstInitial + lastInitial}</span>
    </div>
  );
}

DefaultProfileImage.propTypes = {
  firstInitial: PropTypes.string,
  lastInitial: PropTypes.string
};
